<div class="result">
  <div class="row">
    <div class="col-12">
      <button
        class="result__close"
        (click)="close()">
        <span class="icon">&#65291;</span>
      </button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="ex-exercise_icon">
        <img 
          class="ex-exercise_icon__good"
          *ngIf="isExExerciseActive && exExerciseResult"
          src="/assets/images/icons/smile_good.png">
        <img 
          class="ex-exercise_icon__bad"
          *ngIf="isExExerciseActive && !exExerciseResult"
          src="/assets/images/icons/smile_bad.png">
    </div>
    <div class="col-12">
      <div class="result__title">
        Верно {{ correctExercisesCount }} из {{ exercisesCount }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="result__exercises" *ngIf="card.exercises.length > 0 && answers.length > 0">
        <app-result-exercises
          [exercises]="card.exercises"
          [studentAnswers]="answers">
        </app-result-exercises>
      </div>
    </div>
  </div>
  <div class="result__actions" *ngIf="student">
    <p class="student-fullname">{{student.name}} {{student.surname}}</p>
    <div class="result__submit">
      <button
        class="submit__button submit__button_cash"
        (click)="acceptToCash()">
        <span class="type">
          <span class="type__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
              <style>
                .cash-1 {
                  fill: #fff;
                }

                .cash-2 {
                  fill: none;
                }
              </style>
            </defs>
            <g>
              <g>
                <path class="cash-1" d="M10,8a4,4,0,1,1,6.62,3H18a5,5,0,1,0-8,0h1.36A4,4,0,0,1,10,8Z"></path>
                <path class="cash-1" d="M16,8a2,2,0,1,0-.28,1H14V8Z"></path>
                <rect class="cash-2" width="24" height="24"></rect>
                <rect class="cash-2" width="24" height="24"></rect>
                <path class="cash-1"
                      d="M6,13l8-1v2L9,15v1h6l6-6,1,1-6,8H7L4,22,1.47,20.13a1.58,1.58,0,0,1-.18-2.38Z"></path>
              </g>
            </g>
          </svg>
        </span>
          <span class="type__text">Наличными</span>
        </span>
        <span class="value" [ngClass]="adaptAmountSize(amount)">
          <span *ngIf="amount !== 0">{{isReward ? '+' : '-'}}</span>{{ amount + exExerciseReward }}
        </span>
      </button>
      <div class="student">
        <div class="student__image-wrapper">
          <div
            class="student__image-circle"
            [ngClass]="setGender()">
            <div class="student__image">
              <img
                class="image"
                *ngIf="student.photo_url; else initiatives;"
                [src]="MAIN_DOMAIN + student.photo_url"
                [alt]="student.name">
              <ng-template #initiatives>
                <span class="initiatives">
                  {{student.name.charAt(0)}} {{student.surname.charAt(0)}}
                </span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <button
        class="submit__button submit__button_account"
        (click)="acceptToAccount()">
        <span class="value" [ngClass]="adaptAmountSize(amount)">
          <span *ngIf="amount !== 0">{{isReward ? '+' : '-'}}</span>{{ amount + exExerciseReward }}
        </span>
        <span class="type">
          <span class="type__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
              <style>
                .account-1 {
                  fill: none;
                }

                .account-2 {
                  fill: #fff;
                }

                .account-3 {
                  fill: #fff;
                }
              </style>
            </defs>
            <g>
              <g>
                <rect class="account-1" width="24" height="24"></rect>
                <path class="account-2"
                      d="M8,7a4,4,0,0,1,8,0,4,4,0,0,1-.56,2h1.13A5,5,0,1,0,7.42,9H8.56A4,4,0,0,1,8,7Z"></path>
                <polygon class="account-3" points="5 9 5 13 9 13 5 9"></polygon>
                <path class="account-2"
                      d="M22,13v1H20.65c-1.07-2.31-4.53-4-8.65-4a14.52,14.52,0,0,0-6,1l-1,.75V15H4V12.5L2,14H1v3H2l5,3v2H9V20.78A22.85,22.85,0,0,0,12,21a14.28,14.28,0,0,0,3-.32V22h2V20.08c2.42-1,4-2.67,4-4.58a3.42,3.42,0,0,0,0-.5h2V13ZM9,13,8,12h8l1,1Z"></path>
                <rect class="account-2" x="21" y="12" width="1" height="1"></rect>
                <rect class="account-1" width="24" height="24"></rect>
                <rect class="account-3" x="7" y="19" width="10" height="1"></rect>
                <path class="account-2" d="M12,7h2a2,2,0,1,0-.28,1H12Z"></path>
                <rect class="account-1" width="24" height="24"></rect>
              </g>
            </g>
          </svg>
        </span>
          <span class="type__text">
            {{isReward ? 'На счет' : 'Со счета'}}
          </span>
        </span>
      </button>
    </div>
  </div>
</div>
